/* eslint-disable i18next/no-literal-string */
import type { Router } from '@aikoa/api'
import { transformer } from '@aikoa/common'
import { QueryClient } from '@tanstack/react-query'
import { createTRPCClient, httpLink, loggerLink, type TRPCClient } from '@trpc/client'
import { createTRPCOptionsProxy, type TRPCOptionsProxy } from '@trpc/tanstack-react-query'
import { Platform } from 'react-native'
import { apiHost } from '~/api.ts'
import { appFetchWithCredentials } from '~/lib/fetch'
import { supabase } from '~/lib/supabase'

export const queryClient = new QueryClient()

export const trpcClient: TRPCClient<Router> = createTRPCClient<Router>({
  links: [
    loggerLink({
      enabled: () => false,
      colorMode: Platform.OS === 'web' ? 'css' : 'ansi',
    }),
    httpLink({
      url: `${apiHost}/trpc`,
      headers: async () => {
        const headers = new Map<string, string>()

        const {
          data: { session },
        } = await supabase.auth.getSession()

        const accessToken = session?.access_token

        if (accessToken) {
          headers.set('authorization', accessToken)
        }

        return Object.fromEntries(headers)
      },
      fetch: appFetchWithCredentials,
      transformer,
    }),
  ],
})

export const trpc: TRPCOptionsProxy<Router> = createTRPCOptionsProxy<Router>({
  client: trpcClient,
  queryClient,
})
